import React from 'react';
import { PRODUCT_IMG, PRODUCT_NAME } from './constants';
const modules = [{
  num: '1',
  title: 'Gymnastics Foundations™',
  description: 'Master the essential coaching principles, safety guidelines, warm-up routines, body positions, and fundamental gymnastics skills needed to build a strong foundation for athletes of every age and level.'
}, {
  num: '2',
  title: 'Skill Progression Library™',
  description: 'A complete collection of step-by-step skill progressions designed to safely teach, develop, and refine gymnastics techniques while building confidence and reducing frustration.'
}, {
  num: '3',
  title: 'Practice Builder System™',
  description: 'Professional planning templates and coaching frameworks that allow you to build structured, engaging, and effective gymnastics practices in just minutes.'
}, {
  num: '4',
  title: 'Ready-to-Use Practice Plans™',
  description: 'A large library of complete practice sessions for beginner, intermediate, and advanced gymnasts, ready to use or easily adapt to your athletes.'
}, {
  num: '5',
  title: 'Season Planning System™',
  description: 'Professional season planning resources including weekly schedules, long-term athlete development, competition preparation, training cycles, and goal-setting systems.'
}, {
  num: '6',
  title: 'Coaching Toolkit™',
  description: 'Essential coaching resources including athlete evaluations, skill checklists, progress trackers, attendance sheets, practice planners, and daily coaching tools to keep every session organized.'
}];
export function SystemSection() {
  return <section className="py-8 px-4 bg-white" data-id="element-167">
      <div className="max-w-4xl mx-auto" data-id="element-168">
        <div className="text-center mb-6" data-id="element-169">
          <p className="text-sm font-extrabold text-brand-blue uppercase tracking-widest mb-1" data-id="element-170">
            The Solution You've Been Looking For
          </p>
          <h2 className="text-2xl sm:text-3xl font-display font-extrabold text-brand-ink mb-1 uppercase leading-tight" data-id="element-171">
            One Complete 6-in-1 Gymnastics Coaching System
          </h2>
          <p className="text-base font-bold text-brand-navy mb-3" data-id="element-172">
            6 Professional Modules In One Complete Gymnastics Coaching System
          </p>
          <div className="inline-block bg-brand-navy text-white px-4 py-1.5 rounded-lg mb-3 shadow-md" data-id="element-173">
            <p className="font-bold text-sm sm:text-base tracking-wide font-display" data-id="element-174">
              🤸 {PRODUCT_NAME} — Complete 6-in-1 Planning System
            </p>
          </div>
          <p className="text-base text-brand-slate font-medium max-w-3xl mx-auto leading-snug" data-id="element-175">
            {PRODUCT_NAME} is much more than a collection of drills and practice
            ideas. It's a complete coaching system designed to help gymnastics
            coaches plan practices faster, teach skills more effectively,
            organize athlete development, simplify season planning, and coach
            every session with greater confidence.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-3" data-id="element-176">
          {modules.map(m => <a href="#pricing" key={m.num} className="bg-brand-cloud border border-brand-line p-3 rounded-xl flex gap-3 items-start shadow-sm hover:border-brand-blue hover:shadow-md transition-all cursor-pointer group" data-id="element-177">
              <div className="bg-brand-navy text-white font-display font-bold w-9 h-9 flex items-center justify-center rounded-lg shrink-0 group-hover:bg-brand-blue transition-colors" data-id="element-178">
                {m.num}
              </div>
              <div data-id="element-179">
                <h3 className="text-sm sm:text-base font-bold text-brand-ink leading-tight" data-id="element-180">
                  ✅ {m.title}
                </h3>
                <p className="text-brand-slate text-xs sm:text-sm font-medium mt-0.5 leading-snug" data-id="element-181">
                  {m.description}
                </p>
              </div>
            </a>)}
        </div>

        <div className="mt-6 text-center" data-id="element-182">
          <a href="#pricing" className="inline-block cursor-pointer" data-id="element-183">
            <img src={PRODUCT_IMG} alt="Gymnastics Coach Pro 6-in-1 System" className="w-full max-w-xs mx-auto object-contain drop-shadow-xl hover:scale-[1.02] transition-transform duration-300" data-id="element-184" />
          </a>
        </div>
      </div>
    </section>;
}